import { Navigate, Outlet } from 'react-router-dom'
import { useCurrentUser } from '../hooks/useCurrentUser'

export function ProtectedRoute() {
  const { user, loading, isPending, isBlocked } = useCurrentUser()

  if (loading) {
    return (
      <div className="min-h-screen bg-light-body flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-orion-primary border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  if (isBlocked) return <Navigate to="/blocked" replace />
  if (isPending) return <Navigate to="/pending" replace />

  return <Outlet />
}

export function AdminRoute() {
  const { user, loading, isAdmin, isPending, isBlocked } = useCurrentUser()

  if (loading) {
    return (
      <div className="min-h-screen bg-light-body flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-orion-primary border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  if (isBlocked) return <Navigate to="/blocked" replace />
  if (isPending) return <Navigate to="/pending" replace />
  if (!isAdmin) return <Navigate to="/projects" replace />

  return <Outlet />
}
